import React from "react";
import "./dashboard.css";
import Sidebar from "../../components/admin/sidebar/Sidebar";
import useDash from "../../assets/css/dash.module.css";
import Home from "../Home/Home";
import { ToastContainer } from "react-toastify";
import useISPowner from "../../hooks/useISPOwner";
import Dashboard from "../Home/Dashboard";

export default function AdminDashboard() {
  //---> Get user & current user data form useISPOwner hooks
  const { userData, currentUser } = useISPowner();

  return (
    <>
      <Sidebar />
      <ToastContainer position="top-right" theme="colored" />
      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            {currentUser?.user?.role === "superadmin" ||
            userData?.permission?.dashboard ? (
              <Home />
            ) : (
              <Dashboard />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
